import config from '@haaretz/l-config';
import usePageType from '@haaretz/s-atoms/pageType';
import { usePathname as useAppPathname, useSearchParams as useAppSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
const appType = config.get('appType');
const ppLandingPages = [
    '/supportHaaretz'
];
const appsLandingPages = [
    '/printSubscription'
];
function usePagesPathname() {
    const router = useRouter();
    return router.pathname;
}
export default function useBiPageType() {
    const pageType = usePageType();
    // eslint-disable-next-line react-compiler/react-compiler
    const usePathname = appType === 'promotions-page' ? usePagesPathname : useAppPathname;
    const useSearchParams = // eslint-disable-next-line react-compiler/react-compiler
    appType === 'promotions-page' ? ()=>null : useAppSearchParams;
    // eslint-disable-next-line react-compiler/react-compiler
    const pathname = usePathname();
    // eslint-disable-next-line react-compiler/react-compiler
    const searchParams = useSearchParams();
    if (appType === 'promotions-page') {
        if (ppLandingPages.some((landingPage)=>pathname?.endsWith(landingPage))) {
            return 'LandingPage';
        }
        return 'Promotions';
    }
    if (appType === 'login') {
        if (searchParams?.has('familyToken')) {
            return 'Personal';
        }
        return 'Login';
    }
    if (pageType.endsWith('Article')) {
        return 'Article';
    }
    if (pageType === 'Homepage') {
        return pageType;
    }
    if (pathname?.includes('ty-search')) {
        return 'Search';
    }
    if (pathname?.startsWith('/chatbot/')) {
        return 'Chatbot';
    }
    if (appsLandingPages.some((landingPage)=>pathname?.endsWith(landingPage))) {
        return 'LandingPage';
    }
    return 'Section';
}

//# sourceMappingURL=useBiPageType.js.map